import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { Tag, Tooltip } from 'antd';
import { CustomLabel8 } from '@4beefopag/4bee-fopag-core/dist/atoms';
import moment from 'moment';
import { Cell } from '../../atoms/Table';

const COLABORADOR_AFASTADO = 'afastado';
const COLABORADOR_SEM_CONTRATO = 'sem_contrato';
const COLABORADOR_CONTRATADO = 'contratado';
const COLABORADOR_PENDENCIA_ESOCIAL = 'esocial_pendente';

// @TODO: Criar um teste unitário para as cores
const getStatusAdesaoColaborador = (colaboradorParam) => {
  const { hasSignedContract, removalDate, isEsocialIncluded } = colaboradorParam;
  if (removalDate) {
    return COLABORADOR_AFASTADO;
  }

  if (!isEsocialIncluded) {
    return COLABORADOR_PENDENCIA_ESOCIAL;
  }

  if (hasSignedContract) {
    return COLABORADOR_CONTRATADO;
  }

  return COLABORADOR_SEM_CONTRATO;
};

function NomeColaboradorCell({ colaborador, icon }) {
  const theme = useTheme();

  const COLOR_MAP_CONTRATO_COLABORADOR = {
    [COLABORADOR_AFASTADO]: theme.corColaboradorAfastado,
    [COLABORADOR_SEM_CONTRATO]: theme.corColaboradorSemContrato,
    [COLABORADOR_PENDENCIA_ESOCIAL]: theme.corColaboradorPendenciaESocial,
    [COLABORADOR_CONTRATADO]: null,
  };

  const statusAdesaoColab = getStatusAdesaoColaborador(colaborador);
  const corContratoColab = COLOR_MAP_CONTRATO_COLABORADOR[statusAdesaoColab];

  const toolTipRows = [];
  if (colaborador.dataInicioProjeto) {
    toolTipRows.push(
      `Data de início de projeto: ${moment(colaborador.dataInicioProjeto, 'M/D/YYYY').format('DD/MM/YYYY')}`
    );
  }

  if (statusAdesaoColab === COLABORADOR_AFASTADO && colaborador.removalDate) {
    toolTipRows.push(`Data Afastamento: ${colaborador.removalDate}`);
  }

  return (
    <Cell
      fixed
      width="210px"
      left="100px"
    >
      <Tag color={corContratoColab}>
        {icon}
        {toolTipRows.length > 0 ? (
          <Tooltip title={toolTipRows.join('\n')}>
            <CustomLabel8 color={corContratoColab && '#ffffff'}>{colaborador.name}</CustomLabel8>
          </Tooltip>
        ) : (
          <CustomLabel8 color={corContratoColab && '#ffffff'}>{colaborador.name}</CustomLabel8>
        )}
      </Tag>
    </Cell>
  );
}

NomeColaboradorCell.propTypes = {
  colaborador: PropTypes.shape().isRequired,
  icon: PropTypes.element.isRequired,
};

export default NomeColaboradorCell;
